export default {
    CREATE_COLUMN: () => '/boardList/createBoardList',
    RENAME_COLUMN: (id) => `/boardList/updateBoardList/${id}`,
    DELETE_COLUMN: (id) => `/boardList/deleteBoardList/${id}`
};
